// extracted by mini-css-extract-plugin
export var MultiImageLayout = "MultiImageLayout-module--MultiImageLayout--aMKud";
export var aniSpin = "MultiImageLayout-module--ani-spin---le00";
export var column = "MultiImageLayout-module--column--nQi3t";
export var column__spacer = "MultiImageLayout-module--column__spacer--zDXvo";
export var container = "MultiImageLayout-module--container--8OjkE";
export var description = "MultiImageLayout-module--description--fVDhL";
export var imageLink = "MultiImageLayout-module--imageLink--enFWI";
export var inner = "MultiImageLayout-module--inner--eaiUn";